import { http } from './http';
import { ROUTES } from './config';
import type { DlqList, ServiceRegistry } from '../types/domain';

/**
 * Gateway service-registry + OrderService DLQ-ops clients. Distinct from admin-dashboard's
 * local `lib/ops.ts` (a separate, currently-broken AI-ops-agent integration at `/ai-ops` —
 * see that route's own notes) — this hits real, working gateway/backend surface instead.
 */
export const systemHealthApi = {
  /** Manager+ only — live YARP cluster/destination health for every routed service. */
  registry(): Promise<ServiceRegistry> {
    return http.get(ROUTES.registry);
  },

  /** Admin only — OrderService's dead-letter backlog (the one real-ecommerce service that
   * actually consumes a queue today; see OrderService/Program.cs's AddConsumerQueue call). */
  orderDlq(status?: string, take?: number): Promise<DlqList> {
    const params = new URLSearchParams();
    if (status) params.set('status', status);
    if (take) params.set('take', String(take));
    const qs = params.toString();
    return http.get(`${ROUTES.opsOrderDlq}${qs ? `?${qs}` : ''}`);
  },

  retryOrderDlqEvent(id: string): Promise<{ id: string; status: string; retryCount: number }> {
    return http.post(`${ROUTES.opsOrderDlq}/${id}/retry`, undefined);
  },

  discardOrderDlqEvent(id: string): Promise<void> {
    return http.post(`${ROUTES.opsOrderDlq}/${id}/discard`, undefined);
  },
};
